
        require('./index.scss');
        'use strict';

var $ = window.$;
var mod = $('.related');
var _module = {
    init: function init() {
        var url = window.location.href;
        if (typeof url === 'string') {
            var type = /zixun|gonglue/.exec(url) && /zixun|gonglue/.exec(url)[0];
            if (type === 'gonglue') {
                mod.find('.sidebar-head').text('相关攻略');
            }
        }
    }
};
_module.init();;
    


// WEBPACK FOOTER //
// ./src/module/home-detail/related/index.js